
export default {
  name: 'MoleculeProjectPortfolio'
}
